const CHECK_TASKNAME = ['DocGen', 'Document', 'Trial'];

module.exports = {
  CHECK_TASKNAME,
};
